import { useKioskState } from '../../context/Kiosk/kiosk';
import { useLocalization } from '../../context/Localization/localization';
import css from './index.module.scss';

export const KioskDisclaimer = () => {
    const kiosk = useKioskState();
    const Localization = useLocalization();
    const disclaimer = kiosk.dealer.localization.workAuthorizationDisclaimer || Localization.IHereByAuthorize;

    return (
        <>
            {
                <div className={css.disclaimer}>
                    <p>{disclaimer}</p>
                </div>
            }
        </>
    );
};
